import { fmtTL, fmtNum, fmtDate, fmtCreator } from "../../lib/format";

const fmtLogVal = (field, v) => {
  if (v === null || v === undefined || v === "") return "—";
  if (field === "entry_date") return fmtDate(v);
  if (field.endsWith("_unit_price")) return fmtTL(v);
  if (field === "quantity") return fmtNum(v);
  return String(v);
};

export function EditLogRow({ entry, colSpan, userLabels }) {
  return (
    <tr className="bg-sky-50/70 border-t border-sky-100" data-testid={`entry-editlog-${entry.id}`}>
      <td colSpan={colSpan} className="px-4 py-2">
        <div className="text-[10px] font-bold uppercase tracking-wide text-sky-800 mb-1">Düzeltme İzi — {entry.edit_log.length} düzeltme</div>
        <div className="space-y-1">
          {[...entry.edit_log].reverse().map((l) => (
            <div key={l.at} className="text-[11px] text-slate-700 flex flex-wrap gap-x-3 gap-y-0.5">
              <span className="font-semibold whitespace-nowrap">{fmtCreator(l.by, l.at, userLabels)}</span>
              {l.changes.map((c) => <span key={c.field || c.label} className="whitespace-nowrap"><span className="text-slate-500">{c.label}:</span> <span className="line-through text-red-700">{fmtLogVal(c.field, c.old)}</span> → <span className="font-semibold text-emerald-800">{fmtLogVal(c.field, c.new)}</span></span>)}
            </div>
          ))}
        </div>
      </td>
    </tr>
  );
}
